import React, { Suspense, useState } from 'react'
import CustomCarousel from '../CustomCarousel/CustomCarousel'
import MediaModal from '../Modals/MediaModal/MediaModal';
import { Play } from 'lucide-react';
import { Link } from '@remix-run/react';
import { getRegionUrlPrefix } from '~/lib/helpers/slugHelper';

const TrainingVideosScection = ({ media, country }) => {
  const [mediaModal, setMediaModal] = useState(false);
  const [currentMedia, setCurrentMedia] = useState(null);
  return (
    <section className="">
      {mediaModal && (
        <Suspense fallback={<div className="p-4">Loading...</div>}>
          < MediaModal media={currentMedia} setVisible={setMediaModal} />
        </Suspense >
      )}
      <div className="flex justify-between items-end my-6">
        <h2 className="text-xl font-bold leading-none">TRAINING LIBRARY</h2>
        <div className=" hidden md:block h-[2px] bg-[#0068B1] flex-1 mx-4" />
        <Link
          to={`${getRegionUrlPrefix(country)}/blog/training-library`}
          className="hidden md:block text-sm text-[#0068B1]  hover:underline leading-none"
        >
          See more Training Views
        </Link>
      </div>

      <div className="">
        <CustomCarousel items={media?.length ? media.map((video, idx) => (
          <div
            key={idx}
            className="rounded-lg border  hover:shadow-lg transition w-full md:w-[45.5%] lg:w-[350px] flex-shrink-0"
          >
            <div className="relative">
              <img
                src={`https://ik.imagekit.io/officehub/tr:h-960,fo-auto,f-avif/${video.thumbnail}`}
                alt={video.title}
                className="w-full h-48 object-cover rounded-t-lg"
              />
              <button onClick={() => {
                setCurrentMedia(video)
                setMediaModal(true)
              }} className="absolute inset-0 flex items-center justify-center bg-black/40 text-white rounded-t-lg">
                <Play className="w-10 h-10" />
              </button>

            </div>
            <div className="p-4">

              <p className="text-sm font-semibold mb-2 line-clamp-1">
                {video.title}
              </p>
              <div className="flex justify-between text-xs text-gray-500">
                <span>{video.duration}</span>
                <span>{video.date}</span>
              </div>
            </div>
          </div>
        )) : []} />
      </div>


    </section>
  )
}

export default TrainingVideosScection